export class Progress {
  /** список движущихся цветных прогресс-баров */
  private progressbars: HTMLElement[] = []

  /** 
   *@param progressList родительский UL для списка прогресс-баров
    На него будет срабатывать Observer пересечения
   */
  constructor(progressList: HTMLElement) {
    progressList.querySelectorAll<HTMLElement>('.progress-list__item, .progress-bar').forEach(progressbar => {
      this.progressbars.push(progressbar)
    })
    this.observe(progressList)
  }

  /** навесить Observer пересечения на родительский UL  */
  private observe(progressList: HTMLElement) {
    const options = {
      threshold: 0.8
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        this.progressbars.forEach(progressbar => {
          progressbar.getAnimations().forEach(animation => animation.play())
        })
        observer.unobserve(entry.target)
      })
    }, options)
    observer.observe(progressList)
  }
}
